/**
 * Icon
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import icons from './icons';
var getSize = function (size) {
    switch (size) {
        case 0.625:
            return 'w-2.5 h-2.5';
        case 0.75:
            return 'w-3 h-3';
        case 0.875:
            return 'w-3.5 h-3.5';
        case 1:
            return 'w-4 h-4';
        case 1.25:
            return 'w-5 h-5';
        case 2:
            return 'w-6 h-6';
        case 2.5:
            return 'w-7 h-7';
        case 3:
            return 'w-8 h-8';
        case 4:
            return 'w-10 h-10';
        case 5:
            return 'w-12 h-12';
        case 6:
            return 'w-14 h-14';
        case 7:
            return 'w-16 h-16';
    }
};
var getRotation = function (direction) {
    switch (direction) {
        case 'up':
            return '-rotate-90';
        case 'right':
            return 'rotate-0';
        case 'down':
            return 'rotate-90';
        case 'left':
            return 'rotate-180';
    }
};
/** This is the icon component that handles all the icons in the project. <br /> The user will be able to set the <strong>color</strong>, <strong>size</strong>, <strong>direction</strong> and <strong>animation</strong> for all the icons. */
var Icon = function (_a) {
    var icon = _a.icon, _b = _a.size, size = _b === void 0 ? 1 : _b, _c = _a.direction, direction = _c === void 0 ? 'right' : _c, _d = _a.animate, animate = _d === void 0 ? undefined : _d, className = _a.className, expanded = _a.expanded, htmlAttributes = __rest(_a, ["icon", "size", "direction", "animate", "className", "expanded"]);
    var IconSvg = icons[icon];
    return (React.createElement(IconSvg, __assign({ className: clsx(className, 'inline-block', 'align-middle', 'transition-all', 'duration-300', !animate && 'transform', 'fill-current', getSize(size), getRotation(direction), animate && 'animate-spin'), "data-cid": "Icon" }, htmlAttributes)));
};
export default Icon;
